import React, { Component } from "react";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";

export class LockedPolicy extends Component {
  render() {
    return (
      <Information headerText={Store.ErrorPages.LockedPolicy.HeaderText}>
        <Content name={Store.ErrorPages.LockedPolicy.Message} />
        <ErrorContentLinks />
      </Information>
    );
  }
}

export default LockedPolicy;
